import button from '../button/button'

export default function(o, onSelect){

  var lang = o.store('lang')

  var click = function(lang){
    if(lang != o.store('lang')){
      return function(){
        o.store('lang', lang)
        onSelect(lang)
        o.log('langClick',lang)
      }
    }
  }

  var div =
    $('<div>')
    .addClass('menu')
    .css({
      whiteSpace: 'no-wrap',
      display: 'inline-block',
      verticalAlign: 'bottom',
    })
    .append([
      button(o, 'de', click('de')),
      button(o, 'en', click('en')),
      button(o, 'fr', click('fr')),
      button(o, 'ру', click('ru')),
    ])

  return div

}



// WEBPACK FOOTER //
// ./src/client/view/frontend/components/languages/languages.js